import React, { useContext, useEffect, useState } from 'react';
import { NIBBLE_PROMPT_SUBTITLE } from '../../config/text/text';
import ThemeContext from '../../providers/ThemeProvider';

const NibbleAlertPopup = ({ deal, setNibbleAlertPopup, onButtonClick }) => {
  const theme = useContext(ThemeContext);
  const [isNibbleButtonPresent, setIsNibbleButtonPresent] = useState(false);

  const closeAlert = () => {
    setNibbleAlertPopup(false);
  };

  // Focus management on close button if nibble button does not exist
  useEffect(() => {
    if (!isNibbleButtonPresent) {
      const closeButton = document.querySelector('.close-button-nibble-alert');
      if (closeButton) closeButton.focus();

      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          closeAlert();
        }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [isNibbleButtonPresent]);

  return (
    <div
      aria-describedby="nibble-alert-description"
      aria-labelledby="nibble-alert-title"
      className="nibble-alert-container"
      role="alertdialog"
      tabIndex={-1}
    >
      <button
        aria-label="Close alert"
        className="close-button-nibble-alert"
        onClick={closeAlert}
        tabIndex={0}
      >
        &times;
      </button>
      <div className="nibble-alert-content">
        <p className="nibble-alert-title" id="nibble-alert-title" tabIndex={0}>
          <strong>Still undecided?</strong>
        </p>
        <p
          className="nibble-alert-description"
          id="nibble-alert-description"
          tabIndex={0}
        >
          {NIBBLE_PROMPT_SUBTITLE}
        </p>
        <div className="button-wrapper">
          <button
            className="haggle-button"
            onClick={onButtonClick}
            tabIndex={0}
          >
            HAGGLE
          </button>
        </div>
      </div>
      <style jsx>{`
        .nibble-alert-container {
          position: fixed;
          bottom: 50%;
          right: 6%;
          width: 230px;
          background-color: ${theme.colors.white};
          border-radius: 10px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
          z-index: 10000;
          padding: 8px 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
        }

        .close-button-nibble-alert {
          position: absolute;
          top: -10px;
          right: -10px;
          width: 24px;
          height: 24px;
          background-color: ${theme.colors.gray};
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
          color: ${theme.colors.black};
          cursor: pointer;
        }

        .close-button-nibble-alert:hover {
          background-color: #b3b3b3;
        }

        .nibble-alert-content {
          margin-top: 10px;
        }

        .nibble-alert-title {
          color: ${theme.colors.black};
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .nibble-alert-description {
          color: ${theme.colors.black};
          font-size: 14px;
          margin-bottom: 15px;
        }

        .button-wrapper {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        .haggle-button {
          background-color: transparent;
          color: ${theme.colors.primary};
          border: 3px solid ${theme.colors.primary};
          padding: 6px 20px;
          font-size: 20px;
          font-weight: bold;
          border-radius: 30px;
          cursor: pointer;
          text-transform: uppercase;
          width: 100%;
        }

        .haggle-button:hover {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.white};
        }

        .haggle-button:focus {
          outline: 2px solid #005fcc;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .nibble-alert-container {
            width: 200px;
            padding: 12px;
          }

          .nibble-alert-title {
            font-size: 14px;
          }

          .nibble-alert-description {
            font-size: 12px;
          }

          .haggle-button {
            font-size: 14px;
            padding: 8px 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default NibbleAlertPopup;
